import PropTypes from "prop-types";

export const subclassShape = PropTypes.shape({
  name: PropTypes.string,
  shortDescription: PropTypes.string,
  site_url: PropTypes.string,
});
